export default __webpack_public_path__ + "static/media/icon-metalmold.fae8eae9.svg";